export default "__VITE_ASSET__5f19b08c__"